function consumeVariantData(data, consumers) {
    consumers.forEach(consumer => {
        const target = consumer.getAttribute('consumer')
        switch (target) {
            // Special case for textContent.
            case 'text':
                if(consumer.dataset.consume.includes('.')) {
                    // support one level within object
                    const array = consumer.dataset.consume.split('.')
                    const selectedData = data[array[0]] ? data[array[0]][array[1]] : null
                    if(consumer.textContent !== selectedData) {
                        consumer.setAttribute('consuming', 'true')
                        setTimeout(() => { consumer.setAttribute('consuming', 'false') }, 100)
                        consumer.textContent = data[array[0]] ? selectedData : ''
                    }
                } else {
                    if(consumer.textContent.trim() !== data[consumer.dataset.consume]) {
                        consumer.setAttribute('consuming', 'true')
                        setTimeout(() => { consumer.setAttribute('consuming', 'false') }, 100)
                        consumer.textContent = data[consumer.dataset.consume] ? data[consumer.dataset.consume] : ''
                    }
                }
                break
            // Toggle class with data-class.
            case 'class':
                const name = consumer.dataset.class
                if(name) data[consumer.dataset.consume] ? consumer.classList.remove(name) : consumer.classList.add(name)
                break
            // Toggle unary attributes with data-attribute.
            case 'unary':
                const attr = consumer.dataset.attribute
                if(attr) data[consumer.dataset.consume] ? consumer.removeAttribute(attr) : consumer.setAttribute(attr, '')
                break
            case 'truthy':
                const comparison = consumer.dataset.comparison.split(/(=+)/)
                if(data[comparison[0].trim()].toLowerCase() == comparison.at(-1).trim().toLowerCase()) {
                    consumer.removeAttribute(consumer.dataset.attribute)
                    consumer.setAttribute('consuming', 'true')
                    setTimeout(() => { consumer.setAttribute('consuming', 'false') }, 100)
                } else {
                    consumer.setAttribute(consumer.dataset.attribute, '')
                }
                break
            default:
                consumer.setAttribute(target, data[consumer.dataset.consume])
                break
        }
    })
}